document.querySelectorAll('.single-details a').forEach(link => {
  var text = link.textContent.trim();
  // Verifica se o texto é um link completo
  if (/^https?:\/\//i.test(text)) {
    link.classList.add('inline-url');
  }
});
